import { Pipe, PipeTransform } from '@angular/core';

import { ApplicationUtilsService } from '@util-services';

@Pipe({
  name: 'lengthValue',
  standalone: false,
})
export class LengthValuePipe implements PipeTransform {
  constructor(public appController: ApplicationUtilsService) {}

  async transform(value: string): Promise<string> {
    if (!value) {
      return value;
    }

    let length = null;
    if (value.indexOf('E.') == 0) {
      length = 4000;
    } else {
      length = await this.appController.getLength(value);
    }

    return length;
  }
}
